import { makeStyles } from "@material-ui/core/styles";
import { TableCell } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import { Badge } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  greyRatio: {
    color: "black",
    background: "#D3D3D3",
  },
  warningRatio: {
    color: "white",
    background: "#eed202",
  },
  dangerRatio: {
    color: "white",
    background: "#F32013",
  },
  successRatio: {
    color: "white",
    background: "#4BB543",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  attendanceStatusBadgeSuccess: {
    backgroundColor: "#54afe2",
    color: "white",
  },
  attendanceStatusBadgeDanger: {
    backgroundColor: "#dc3545",
    color: "white",
  },

}));

export default function SchoolProgramAttendanceRowReport(props) {
  const { row, reset, setReset, showActions } = props;
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  const handleRowClick = () => {
    setOpen(!open);
    reset && setReset(false);
  };

  return (
    <Fragment>
      <TableRow key={`${row.student_id}`} hover tabIndex={-1}>
        <TableCell align="center" component="th" scope="row">
          {row.school_name}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.day}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.program_time}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.program_duration}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          <Badge pill className={classes.greyRatio}>
            {row.course_abbr}
          </Badge>
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.student_id}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.student_name}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.parent_name}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.phone}`}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {`${row.sessions}`}
        </TableCell>




      </TableRow>
    </Fragment>
  );
}
